import type { TripStatus } from '@raahi/shared';

const COPY: Record<TripStatus, { label: string; tone: string }> = {
  requested: { label: 'Requesting', tone: 'bg-line text-ink' },
  searching: { label: 'Finding driver', tone: 'bg-ink text-white' },
  assigned: { label: 'Driver assigned', tone: 'bg-ink text-white' },
  arriving: { label: 'On the way', tone: 'bg-ink text-white' },
  arrived: { label: 'Driver arrived', tone: 'bg-accent text-ink' },
  in_progress: { label: 'On trip', tone: 'bg-accent text-ink' },
  completed: { label: 'Completed', tone: 'bg-line text-ink' },
  cancelled: { label: 'Cancelled', tone: 'bg-line text-muted' },
};

export function StatusPill({ status }: { status: TripStatus }) {
  const c = COPY[status];
  return <span className={`pill ${c.tone}`}>{c.label}</span>;
}
